import styled from "styled-components";

import { Spin, Typography } from "antd";
import { Link } from "react-router-dom";
import { StatusTagComponent } from "../../../../components";
import RenderMarkdown from "../../../../components/render-markdown.component";
import { useGetRandomColor, useQuery } from "../../../../hooks";
import { useAuth } from "../../../../providers";

const WorkshopGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
  gap: 16px;
  align-items: stretch;
`;

const WorkshopCard = styled.div`
  height: 100%;
  border-radius: 16px;
  padding: 16px 24px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
  gap: 12px;
  text-align: left;
  background-color: var(--color-card-bg, #ffffff);
  border: 1px solid var(--color-card-border, rgba(255, 255, 255, 0.2));
  backdrop-filter: blur(8px);
`;

const CardTop = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const CardDate = styled.span`
  font-size: 14px;
  display: flex;
  align-items: center;
  gap: 4px;
`;

const CardTitle = styled.h3`
  margin: 0;
  font-size: 18px;
  font-weight: bold;
  text-align: left;
`;

const CardCompany = styled.span`
  font-size: 14px;
  color: var(--color-card-company-text, #d9730d);
  text-align: left;
`;

const CardContent = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

const ProjectTags = styled.div`
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
`;

const Tag = styled.div`
  padding: 2px 12px;
  border-radius: 32px;
  font-size: 14px;
  font-weight: 500;
  color: gray;
  font-weight: bold;
  border: 3px solid ${({ $bgColor }) => $bgColor};
`;

const CardFooter = styled.div`
  display: flex;
  justify-content: flex-end;
`;

export const FilteredWorkShops = ({ activeTab = "all" }) => {
  const { user } = useAuth();
  const { getRandomColor } = useGetRandomColor();

  let urlRole = "/workshop";

  if (user?.role === "ROLE_USER") {
    urlRole = `/workshop/user/${user.id}`;
  }

  const { data: workshops, loading } = useQuery({
    url: urlRole,
    options: { method: "GET" },
  });

  return loading ? (
    <Spin size="large" justify="center" />
  ) : (
    <WorkshopGrid>
      {workshops
        ?.sort((a, b) => new Date(b.date) - new Date(a.date))
        ?.filter(
          (workshop) => activeTab === "all" || workshop.status === activeTab
        )
        .map((workshop) => (
          <Link
            key={workshop.id}
            to={`/workshops/${workshop.id}`}
            state={workshop}
            style={{ textDecoration: "none", color: "inherit" }} // Para mantener estilos visuales
          >
            <WorkshopCard key={workshop.id}>
              <CardTop>
                <CardDate>
                  <span>
                    {workshop.creationDate || "SIN FECHA DE CREACIÓN"}
                  </span>
                </CardDate>
                <StatusTagComponent status={workshop.status} />
              </CardTop>

              <CardTitle>{workshop.title || "SIN TITULO"}</CardTitle>
              <CardCompany>{workshop.company}</CardCompany>

              <CardContent>
                {workshop.description ? (
                  <div
                    style={{
                      display: "-webkit-box",
                      WebkitLineClamp: 5, // Limita a 5 líneas
                      WebkitBoxOrient: "vertical",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                    }}
                  >
                    <RenderMarkdown markdownContent={workshop.description} />
                  </div>
                ) : (
                  <Typography.Paragraph>
                    SIN DESCRIPCION
                  </Typography.Paragraph>
                )}

                <ProjectTags>
                  {(workshop.hashTags || []).map((tag, index) => (
                    <Tag key={index} $bgColor={getRandomColor()}>
                      {tag}
                    </Tag>
                  ))}
                </ProjectTags>
              </CardContent>
              <CardFooter>
                <p
                  style={{
                    textDecoration: "underline",
                    cursor: "pointer",
                  }}
                >
                  Ver proyecto
                </p>
              </CardFooter>
            </WorkshopCard>
          </Link>
        ))}
    </WorkshopGrid>
  );
};
